/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'fabric.emoji.add.custom.emoji.label': 'Přidat své vlastní emoji',
  'fabric.emoji.add.label': 'Přidat emoji',
  'fabric.emoji.cancel.label': 'Zrušit',
  'fabric.emoji.categories.label': 'Vyberte kategorii smajlíků.',
  'fabric.emoji.categories.search.results': 'Výsledky vyhledávání',
  'fabric.emoji.category.activity': 'Činnosti',
  'fabric.emoji.category.all.uploads': 'Všechny nahrané položky',
  'fabric.emoji.category.flags': 'Vlajky',
  'fabric.emoji.category.foods': 'Jídlo a pití',
  'fabric.emoji.category.frequent': 'Časté',
  'fabric.emoji.category.nature': 'Příroda',
  'fabric.emoji.category.objects': 'Objekty',
  'fabric.emoji.category.people': 'Lidé',
  'fabric.emoji.category.places': 'Cestování a místa',
  'fabric.emoji.category.productivity': 'Produktivita',
  'fabric.emoji.category.symbols': 'Symboly',
  'fabric.emoji.category.user.uploads': 'Vaše nahrané položky',
  'fabric.emoji.choose.file.screenReaderDescription':
    'Vyberte soubor smajlíku. JPG, PNG nebo GIF. Maximální velikost je 1 MB.',
  'fabric.emoji.choose.file.title': 'Vybrat soubor',
  'fabric.emoji.delete.description': 'Veškeré existující výskyty tohoto emoji budou nahrazeny {emojiShortName}',
  'fabric.emoji.delete.label': 'Odstranit',
  'fabric.emoji.delete.screenreader.tooltip': 'Chcete-li odstranit smajlík {shortName}, stiskněte klávesu Backspace.',
  'fabric.emoji.delete.title': 'Odstranit emoji',
  'fabric.emoji.delete.tooltip': 'Odstranit',
  'fabric.emoji.emojipicker.emoi.roledescription': 'tlačítko smajlíku',
  'fabric.emoji.emojipicker.error': 'Chyba',
  'fabric.emoji.error.delete.failed': 'Odstranění se nezdařilo.',
  'fabric.emoji.error.image.too.big': 'Vybraný obrázek je větší než 1 MB.',
  'fabric.emoji.error.invalid.image': 'Vybraný obrázek je neplatný.',
  'fabric.emoji.error.upload.failed': 'Nahrávání se nezdařilo',
  'fabric.emoji.error.upload.timeout': 'Vypršel časový limit nahrávání',
  'fabric.emoji.image.requirements': 'JPG, PNG nebo GIF. Max. velikost je 1 MB.',
  'fabric.emoji.name.ariaLabel': 'Zadejte název nového emotikonu',
  'fabric.emoji.picker': 'Výběr smajlíků',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Výsledky vyhledávání} other {Smajlíky}}',
  'fabric.emoji.pickerlist.tabpanel': 'Panel seznamu a akcí smajlíků',
  'fabric.emoji.placeholder': 'např. ahoj',
  'fabric.emoji.preview': 'Vaše nové emoji {emoji} vypadá skvěle!',
  'fabric.emoji.preview.title': 'Náhled',
  'fabric.emoji.retry.label': 'Zkusit znovu',
  'fabric.emoji.search.label': 'Název smajlíku',
  'fabric.emoji.search.placeholder': 'Vyhledat',
  'fabric.emoji.search.status': 'Zobrazují se všechny smajlíky.',
  'fabric.emoji.select.skin.list.ariaLabel': 'Výběr odstínu pleti',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Vyberte odstín pleti, vybráno: {selectedTone}',
};
